import { EntityLayout } from '@backstage/plugin-catalog';

import { environmentContent } from '../environmentContent';
import { overviewContent } from '../overviewContent/overviewContent';
import { technicalDocumentationContent } from '../technicalDocumentationContent';

export const defaultComponentEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {overviewContent}
    </EntityLayout.Route>
    <EntityLayout.Route path="/environment" title="Environment">
      {environmentContent}
    </EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Docs">
      {technicalDocumentationContent}
    </EntityLayout.Route>
  </EntityLayout>
);
